import React, { Component } from "react";
import ThereIsNoItem from '/components/thereIsNoItem';
import EventTeasers from '/components/Brand/EventTeasers';


class Events extends Component {
  render() {
    const { events, eventNextBtn, nextEventItems } = this.props;
    return (
      events && events.length > 0 ?
        <EventTeasers items={events} nextEventItems={nextEventItems} eventNextBtn={eventNextBtn} />
      :
        <ThereIsNoItem thereIsNoItem="There are no events." /> 
    );
  }
}
export default Events;
